import React from 'react';
import { Button } from 'antd';

function FooterButton(props) {
    const { status, editable, confirm, toggleEditable } = props;
    return (
        <div className="quotation-action">
            {
                status === 'add' &&
                <div>
                    <Button type="primary" onClick={() => confirm()}>上一步</Button>
                    <Button type="primary" style={{ marginLeft: 8 }} onClick={() => confirm(true)}>保存并进入下一步</Button>
                </div>
            }
            {
                status === 'edit' &&
                <div>
                    {
                        editable ?
                            <div>
                                <Button onClick={() => toggleEditable(false)}>取消</Button>
                                <Button type="primary" style={{ marginLeft: 8 }} onClick={() => confirm(true)}>保存</Button>
                            </div>
                        :
                            <Button type="primary" onClick={() => toggleEditable(true)}>编辑</Button>
                    }
                </div>
            }
        </div>
    );
}

export default FooterButton;


// WEBPACK FOOTER //
// ./src/components/quotation/Production/Components/FooterButton.js